import React from "react";
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

import { WP_SITE_URL, MENU_API } from '../constants/constants.js'
import logo from '../assets/pictures/logo-rms.png'

function Menu() {
    const [error, setError] = useState(false)
    const [menuData, setMenuData] = useState({})
    
    useEffect(() => {
        async function fetchMenu() {
            try {
                let url = WP_SITE_URL + MENU_API + 'menu-locations/primary'
                console.log(window.location.origin);
                console.log(WP_SITE_URL)
                 
                console.log(url);
                const response = await fetch(url)
                /*const menuData = await response.json()
                console.log(response);
                console.log(menuData);
                console.log(menuData);*/
                setMenuData(await response.json())
                
                
                            
            } catch (err) {
                console.log(err)
                setError(true)
            } 
        }
        fetchMenu()
    }, [])

    if (error) {
        return <span>Oups il y a eu un problème</span>
    }
    if (Array.isArray(menuData)) {
        console.log(menuData);
        return <div className="main-menu" >
            
            <ul id="menu-primary" className="menu">
                {menuData.map( function (menuItem, i)  {
                    
                    return <li key={i} id={'menu-item-' + menuItem.object_id} className={`menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-${menuItem.object_id}`}><Link to={menuItem.url.replace("/index.php","")}>{menuItem.title}</Link></li>
                })}
            </ul>
            
        </div>
    } else { 
        return <span>Loading...</span>;
    }
}
export default Menu